import React, { useEffect, useState } from 'react';
import './Courses.css';
import caro1 from './Images/cor1.jpg';
import cor2 from  './Images/cor2.jpg';
import cor3 from  './Images/cor3.jpg';
import cor4 from  './Images/cor4.jpg';
import cor5 from  './Images/cor5.png';
import cor6 from  './Images/cor6.png'
// import zodiacwheel from './Images/Zodiac-wheel.png';
function Courses() {
  const [showModal, setShowModal] = useState(false);
const [selectedCourse, setSelectedCourse] = useState(null);
    const headings = [
    "Begin Your Journey Today",
    "Step Into the Light of Your Destiny"
  ];
  const [headingIdx, setHeadingIdx] = useState(0);
  const [blink, setBlink] = useState(true);

  useEffect(() => {
    // Blink for 1.2s, then swap text after 2s
    const blinkTimeout = setTimeout(() => setBlink(false), 1200);
    const swapTimeout = setTimeout(() => {
      setHeadingIdx((idx) => (idx + 1) % headings.length);
      setBlink(true);
    }, 2000);
    return () => {
      clearTimeout(blinkTimeout);
      clearTimeout(swapTimeout);
    };
  }, [headingIdx, blink]);
  const courseList = [
    {
      title: 'பிருகு நந்தி நாடி ஜோதிட அடிப்படை',
      desc: 'Introduction to the ancient Bhrigu Nandi Nadi system, focusing on its core principles, planetary significations, and how to interpret basic charts.',
      img: cor6,
      syllabus:['கிரக காரகத்துவங்கள்',
'ராசியின் குணாதிசயங்கள்', 
	'கிரக நட்பு பகை', 'பஞ்ச பூத தத்துவங்கள்',
	'பார்வைகள் அதன் வித்தியாசங்கள்', 
	'கிரக சேர்க்கை பலன்கள்', 
'தோஷங்கள்', 
	'கிரக வக்கிரம்',
	'கிரக பரிவர்த்தனை', 
	'கோள்சார பலன்கள்'
],
duration: '6 Months / 1 Year'

    },
    {
      title: 'சப்தரிஷி நாடி',
      desc: 'A detailed study of the Saptharishi Nadi manuscripts, learning how to decode predictions, karmic influences, and deeper life insights recorded by the sages.',
      img: cor5,
      syllabus:['பாவ காரகத்துவங்கள்', 
'கிரக && பாவ காரகத்துவத்தின் வித்தியாசங்கள்',
'ஆச்சார்யாவின் பிரபஞ்ச விதிகள் (Universal Law)', 
'வளர்ச்சி & வீழ்ச்சி தரும் பாவங்கள்', 
'பன்னிரு பாவங்களின் பலன்கள்' 
],
duration: '6 Months / 1 Year'
    },
    {
      title: 'நட்சத்திர நாடி',
      desc: 'Training on the Nakshatra-based Nadi system with emphasis on star-based predictions, their significance in personal destiny, and timing of events.',
      img: cor3,
      syllabus:['நட்சத்திரங்களின் தன்மைகள்', 
'உடைப்பட்ட நட்சத்திரங்கள்',
'லக்னம் நின்ற நட்சத்திர பலனறிதல்', 
'சந்திரன் நின்ற நட்சத்திர பலனறிதல்', 
'மற்ற கிரகங்கக் நின்ற நட்சத்திர பலனறிதல்'
],
duration: '6 Months / 1 Year'
    },
    {
      title: 'நாடி ஜோதிட முறையில் பலன்கள்',
      desc: 'Practical application of Nadi astrology for predicting marriage, career, health, and other life events with accuracy using the Nadi principles.',
      img: cor2,
      syllabus:['உடல் ஆரோக்கியம்', 'ஆயுள் பலனறிதல்',
'பொருளாதார காண்டம்',
'வீர்யம் மற்றும் சகோதர காண்டம்',
'ஜாதகரின் கல்வி',
'புத்திர காண்டம்',
'ரோக காண்டம்',
'திருமண காண்டம் & முகூர்த்தம்',
'ஆயுள் காண்டம் மற்றும் தோஷங்கள்',
'பிதுர் காண்டம் மற்றும் உயர்கல்வி',
	'கர்ம காண்டம் (தொழில்)'

],
duration: '6 Months / 1 Year' 
    }
,
  {
      title: 'உயர்நிலை நாடி ஜோதிடம் ',
      desc: 'An advanced-level program exploring complex combinations, rare planetary yogas, and higher techniques used in professional Nadi astrology practice',
      img: caro1,
      syllabus:['நாடி ஜோதிட முறையில் சாமுத்ரிகா லட்சணம்', 
'நாடி ஜோதிட முறையில் கைரேகை பலன்கள்', 
'நாடி ஜோதிட முறையில் வாஸ்து பலன்கள்', 
'நாடி ஜோதிட முறையில் எண்ணியல்', 
	'நாடி ஜோதிட முறையில் பெயரியல்', 
'நாடி ஜோதிட முறையில் அதிர்ஷ்ட கற்கள்', 	'நாடி ஜோதிட முறையில் நிமித்த பலன்கள்', 
'நாடி ஜோதிட முறையில் எண்ணியல் பிரஸன்னம்', 
'நாடி ஜோதிட முறையில் ஹோரா பிரஸன்னம்', 
'நாடி ஜோதிட முறையில் கிரக பிரஸன்னம்',
'Nadi Progression',
],
duration: '6 Months / 1 Year'
    },
      {
      title: 'தொழில்முறை ஜோதிட பயிற்சி ',
      desc: 'Professional-level training designed for aspiring astrologers, covering consultation methods, ethics, remedies, and delivering effective guidance to clients',
      img: cor4,
      syllabus:['150 ஜோதிட விதிகள்',
'உதாரண ஜாதக விளக்கங்கள்', 
],
duration: '6 Months / 1 Year'

    }
  ];


  const handleLearnMore = (course) => {
  setSelectedCourse(course);
  setShowModal(true);
};

console.log(selectedCourse);
// -- Testimonials data & carousel state ---------------------------------
const testimonialsList = [
  { id: 1, name: 'R. Kumar', rating: 5, text: `'I'm so happy to share this! The method of teaching "NADI ASTROLOGY" is excellent – it's easy to understand, with perfect live examples. Understanding the nature of planets is made simple and easy to remember. As you said, Once you start to love astrology. People, incidents, and everything you see with கிரக காரகம்.' You're great, sir; I feel truly blessed to be on this journey with you. My gratitude goes out to both you and the universe for the chance to embark on this journey with you`, link: 'https://search.google.com/local/reviews?placeid=PLACE_ID_1' },
  { id: 2, name: 'S. Priya', rating: 5, text: 'Loved the examples and the teacher’s patience. Worth every penny.', link: 'https://search.google.com/local/reviews?placeid=PLACE_ID_2' },
  { id: 3, name: 'A. Ramesh', rating: 5, text: 'Great course structure and real-life case studies. Very helpful.', link: 'https://search.google.com/local/reviews?placeid=PLACE_ID_3' },
  { id: 4, name: 'Meena S', rating: 4, text: 'Informative and practical. Would love more advanced workshops.', link: 'https://search.google.com/local/reviews?placeid=PLACE_ID_4' },
  { id: 5, name: 'K. Arun', rating: 5, text: 'Clear explanations and excellent follow-up support.', link: 'https://search.google.com/local/reviews?placeid=PLACE_ID_5' },
  { id: 6, name: 'V. Lakshmi', rating: 5, text: 'I gained confidence to read charts on my own. Thank you!', link: 'https://search.google.com/local/reviews?placeid=PLACE_ID_6' },
  { id: 7, name: 'P. Suresh', rating: 4, text: 'Very good course. A few topics could use deeper examples.', link: 'https://search.google.com/local/reviews?placeid=PLACE_ID_7' },
  { id: 8, name: 'R. Anita', rating: 5, text: 'Practical, structured and inspiring. Perfect for beginners.', link: 'https://search.google.com/local/reviews?placeid=PLACE_ID_8' },
  { id: 9, name: 'M. Karthik', rating: 5, text: 'Highly professional and insightful. Strongly suggested for aspiring astrologers.', link: 'https://search.google.com/local/reviews?placeid=PLACE_ID_9' },
  { id: 10, name: 'G. Radha', rating: 5, text: 'Very engaging sessions and useful resources. Great mentor.', link: 'https://search.google.com/local/reviews?placeid=PLACE_ID_10' }
];

const [testiIdx, setTestiIdx] = useState(0);

useEffect(() => {
  const interval = setInterval(() => {
    setTestiIdx((i) => (i + 1) % testimonialsList.length);
  }, 5000);
  return () => clearInterval(interval);
}, []);
  return (
    <div  className="course-page " style={{ height: 'auto', color:'white', padding: '20px' }}>
      <h1 className='section-heading'>Astrology Courses</h1>
        {/* <img src={zodiacwheel} alt="zodiac-wheel" className="zodiac-wheel" ></img> */}
        <section style={{ maxWidth: "900px", margin: "40px auto" }}>
        <p>
          My offline and online courses (in Tamil and English) are designed to
          make astrology simple and practical. From beginners to advanced
          learners, each course is structured with real-life examples and
          actionable techniques.
        </p>
      </section>
       
 <section
        style={{
          margin: "40px auto",
          padding: "20px",
          borderRadius: "10px",
          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
          textAlign: "center",
        }}
      >
        <h2 className={blink ? "blink-text" : ""}>{headings[headingIdx]}</h2>
        <p>
          If you are seeking clarity, guidance, or the knowledge to find answers
          for yourself, you are in the right place. Let’s connect and unlock the
          power of your unique cosmic blueprint.
        </p>
        {/* <ul style={{ textAlign: "left", display: "inline-block" }}>
          <li>Accurate and In-Depth Horoscope Readings</li>
          <li>Personalized Astrology Consultations</li>
          <li>Effective Remedies for Life’s Challenges</li>
          <li>Professional and Structured Astrology Courses</li>
        </ul> */}
     
      
      <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', flexWrap: 'wrap', gap: '24px',marginBottom: '20px' }}>
        {courseList.map((course, idx) => (
          <div className="card" style={{ color:'black', backgroundColor:'white', height:'auto', width: '18rem', boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }} key={idx}>
            <img className="card-img-top" src={course.img} alt="Course" style={{height:'180px', width:'287px'}} />
            <div className="card-body px-3 py-2">
              <p className="card-title">{course.title}</p>
              <p className="card-text">{course.desc}</p>
              <a
              href="#contact"
              className="btn btn-primary"
              onClick={e => {
                e.preventDefault();
                 handleLearnMore(course);
              
              }}
            >
              Learn More
            </a>
            </div>
          </div>
        ))}
      </div>
       </section>
       
      {/* Testimonials carousel/cards */}
  
         <section style={{ textAlign:'center', maxWidth: "1200px", margin: "40px auto" }}>
        <h2 className='fade-in-right'>Our Mission</h2>
        <ul className="about-flex-list fade-in">
          <li> <span className="shiny-text">To Empower and Guide </span></li>
          <li> <span className="shiny-text"> Providing Clarity, not just predictions</span></li>
          <li> <span className="shiny-text"> Giving Practical solutions, not just problems</span></li>
          <li> <span className="shiny-text">Providing Authentic education, not just information</span></li>
        </ul>
        </section>
            
      {/* <div style={{color: '#fff', textAlign: 'center'}}>
        <h1 className='cor-title'>Unlock the Stars secrets </h1>
         <p className='cor-title'>Enroll in Our Certified Astrology Courses Today!</p>
         <span style={{fontSize:'24px'}}>Discover ancient wisdom, modern techniques, and real-life applications of astrology.</span>
      </div> */}
   

      {/* Mission */}
   

      {/* Call to Action */}
      {showModal && selectedCourse && (
  <div
    className="modal fade show"
    tabIndex="-1"
    style={{
      display: 'block',
      background: 'rgba(0,0,0,0.5)',
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100vw',
      height: '100vh',
      zIndex: 2000
    }}
    role="dialog"
    aria-modal="true"
  >
    <div className="modal-dialog" style={{ color:'black', maxWidth: 500, margin: '80px auto' }}>
      <div className="modal-content">
        <div className="modal-header">
          <h5 style={{fontSize:'14px',fontWeight:700}} className="modal-title">{selectedCourse.title}</h5>
          <button type="button" className="btn-close" aria-label="Close" onClick={() => setShowModal(false)}></button>
        </div>
        <div className="modal-body">
          <img src={selectedCourse.img} alt={selectedCourse.title} style={{ width: '100%', borderRadius: '8px', marginBottom: '12px' , maxHeight:'300px'}} />
          <p style={{textAlign:'left'}}>{selectedCourse.desc}</p>
          <h6 style={{color:'black'}}>Syllabus:</h6>
          <ul>
            {selectedCourse.syllabus && selectedCourse.syllabus.map((point, idx) => (
              <li key={idx}>{point}</li>
            ))}
          </ul>
          <div style={{fontSize:'14px'}}> Course duration: {selectedCourse.duration} </div>
        </div>
        
        <div className="modal-footer">
          <button type="button" className="btn btn-secondary" onClick={() => setShowModal(false)}>
            Close
          </button>
        </div>
      </div>
    </div>
  </div>
)}
      
    </div>
  );
}

export default Courses;
